import { normalizeExperienceCompetencyName } from "./experienceIndexCategories";

const GENERIC_GAP_COPY = "This is one of the experiences with the most room to grow versus this comparison role.";

// Third-person consultant dialect of membership-mobile-app Skills Index gap copy.
const COMPETENCY_GAP_COPY: Record<string, string> = {
  admin:
    "Tighter administrative systems would help this person's work hold up as responsibilities grow and free more time for the parts of the job they want to lead.",
  budget:
    "More direct budget ownership would give this person a clearer way to turn priorities into operating decisions and prove what those choices returned.",
  "financial acumen":
    "Stronger financial analysis would help this person evaluate what is working, make recommendations with more evidence, and turn sound instincts into decisions others can support.",
  operator:
    "Building more operating range would make the facility less dependent on heroics and create room for higher-level decisions when the pace picks up.",
  personnel:
    "More experience developing staff would make this person's systems less dependent on them doing the heavy lifting and help the team carry the work consistently.",
  network:
    "Growing a broader PGA network could bring in more benchmarks, ideas, and trusted help when larger decisions arrive.",
  "public speaking":
    "Developing a clearer executive voice could help this person turn what they know into influence in larger rooms and more formal settings.",
  "social media":
    "A stronger digital presence could help more members discover this person's work, keep pipelines active, and support steadier participation.",
  "teaching and coaching":
    "Building more coaching experience could help this person transfer what they know so others can own the work too, not only follow their process.",
  "golf academy":
    "The next opportunity is turning this person's reach into a repeatable academy or multi-week player-development program with a steadier pipeline.",
  technology:
    "More confidence with the systems behind the experience could help this person spot patterns, improve at scale, and give their team evidence instead of guesses.",
  "course maintenance":
    "More range in course and grounds planning would help this person connect playing conditions to the rest of the operation and speak to those tradeoffs with more confidence.",
  "food & beverage":
    "Building more food-and-beverage range would help this person connect hospitality to the rest of the member experience and make those service wins more repeatable.",
  merchandise:
    "Stronger merchandising range would help the shop support the member experience more consistently and tie product decisions to how the business actually performs.",
  "tournament operations":
    "More tournament ownership would help this person evaluate whether an event ran well, how it performed for the facility, and what to change next time."
};

export function getExperienceIndexGapCopy(competencyName: string) {
  return COMPETENCY_GAP_COPY[normalizeExperienceCompetencyName(competencyName)] ?? GENERIC_GAP_COPY;
}
